/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {

    export class MeevoTaxField implements angular.IDirective {

        restrict = "E";
        require = "ngModel";
        scope = {
            ngModel: "=",
            enumType: "@",
            contentKey: "@",
            disabled: "=ngDisabled",
            required: "=ngRequired",
            change: "&ngChange",
            tabIndex: "=?tabIndex",
            tooltip: "@",
            displayNameBinding: "=?",
            isTaxExempted: "=",
            isDefaultValueFromList: "@",
        }

        templateUrl = "app/components/controls/taxFieldTemplate.html";


        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes): void => {
            var taxItemGet = {
                taxItemType: Model.TaxItemTypeEnum[scope.enumType]
            };
            var isCo = this.identity.current().centralOfficeId === this.identity.current().locationId;
            this.dataService.customMethodData("/api/Tax/TaxItemList/", "POST", taxItemGet).then((d: any) => {
                if (d.data == null || d.data.length === 0 || isCo)
                    scope.taxDatas = [{
                        id: emptyGuid(),
                        displayName: 'Use Default Tax',
                        taxItemRates: [{ taxRate: 0.00 }]
                    }];
                else
                    scope.taxDatas = d.data;
                scope.getTaxRates(scope.ngModel);
            });

            scope.$watch('ngModel', function (newVal) {
                if (scope.taxDatas) {
                    var temp: any = _.findWhere(scope.taxDatas, { id: parseInt(newVal) });
                    scope.displayNameBinding = temp ? temp.displayName : undefined;
                }
            });


            scope.getTaxRates = function (item) {
                if (Model.Guard.isSomething(scope.taxDatas) && Model.Guard.isSomething(item)) {
                    if (scope.taxDatas.length === 1 && scope.taxDatas[0].id === emptyGuid()) {
                        scope.taxRates = scope.taxDatas[0].taxItemRates;
                    } else {
                        var findCriteria = item !== emptyGuid() ? { id: item } : { isDefault: true };
                        var temp: any = _.findWhere(scope.taxDatas, findCriteria);
                        scope.taxRates = temp.taxItemRates;

                        if (item === emptyGuid()) scope.ngModel = temp.id;
                        else scope.ngModel = item;
                    }
                }
                else if (!scope.ngModel) {
                    var defaultItem = scope.taxDatas.find(item => item.isDefault === true);
                    if (scope.isDefaultValueFromList && defaultItem) {
                        scope.ngModel = defaultItem.id;
                        scope.taxRates = defaultItem.taxItemRates;
                    }
                    else if (scope.taxDatas.length === 1) {
                    scope.ngModel = null;
                    scope.taxRates = scope.taxDatas[0].taxItemRates;
                    }
                }
            }
        }

        constructor(private dataService: Meevo.Components.BaseClasses.IDataService, private identity: Meevo.Components.Common.IIdentityService) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = (dataService: Meevo.Components.BaseClasses.IDataService, identity: Meevo.Components.Common.IIdentityService) => {
                return new MeevoTaxField(dataService, identity);
            };

            directive.$inject = ["meevo.components.common.DataService", "meevo.components.common.IdentityService"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoTaxField", MeevoTaxField.factory());
}